import axios from 'axios'

const API_BASE = process.env.VUE_APP_API_ENDPOINT || '/api'

const newsletterApi = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
})

export function subscribeNewsletter(payload) {
  return newsletterApi.post('/newsletter/subscribe', payload)
}

export function unsubscribeNewsletter(token) {
  return newsletterApi.get('/newsletter/unsubscribe', {
    params: { token },
  })
}
